import { Injectable } from '@angular/core';
import { MsisdnProcedureInterface } from '../models/msisdn-procedure.interface';
import { AlertMessageInterface } from '../../shared/models/alert-message.interface';
import { GetAlertMessage } from '../../shared/store/actions/alert-message.actions';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../helpers/consts.helper';
import { LineInterface } from '../models/line.interface';
import { LineInterfaceState } from '../store/state/line.state';

@Injectable()
export class DisplayProcedureMessageService {

  constructor(private store: Store<any>) {
  }

  customerLine = this.store.pipe(select(ConstsHelper.REDUCER_LINE)).subscribe((response: LineInterfaceState) => {
    if (response.line != null) {
      this.selectedLine = response.line;
    }
  });
  selectedLine: LineInterface;

  displayInProgressMessage(procedure: MsisdnProcedureInterface) {
    let alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_BY_SUPPORT, code: 300 } as AlertMessageInterface;
    if (procedure.status === ConstsHelper.PROCEDURE_STATUS_IN_PROGRESS) {
      let isActive = false;
      if (procedure.lastMessage !== null && procedure.lastMessage['data'] && procedure.lastMessage['data']['active']) {
        isActive = procedure.lastMessage['data']['active'];
      }
      switch (procedure.code) {
        case ConstsHelper.PROCEDURE_SURTAX_NUMBER:
          if (isActive === true) {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_BLOCKING_SURTAX_NUMBERS, code: 300 } as AlertMessageInterface;
          } else {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_UNBLOCKING_SURTAX_NUMBERS, code: 300 } as AlertMessageInterface;
          }
          break;
        case ConstsHelper.PROCEDURE_TOGGLE_SMS_INTERNET_PLUS:
          if (isActive === true) {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_BLOCKING_TOGGLE_SMS_INTERNET_PLUS, code: 300 } as AlertMessageInterface;
          } else {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_UNBLOCKING_TOGGLE_SMS_INTERNET_PLUS, code: 300 } as AlertMessageInterface;
          }
          break;
        case ConstsHelper.PROCEDURE_BLOCKING_MULTIMEDIA_PURCHASE:
          if (isActive === true) {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_BLOCKING_MULTIMEDIA_PURCHASE, code: 300 } as AlertMessageInterface;
          } else {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_UNBLOCKING_MULTIMEDIA_PURCHASE, code: 300 } as AlertMessageInterface;
          }
          break;
        case ConstsHelper.PROCEDURE_THREE_WAY_CONFERENCE:
          if (isActive === true) {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_THREE_WAY_CONFERENCE_ACTIVATION, code: 300 } as AlertMessageInterface;
          } else {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_THREE_WAY_CONFERENCE_DESACTIVATION, code: 300 } as AlertMessageInterface;
          }
          break;
        case ConstsHelper.PROCEDURE_CONTACTS:
          if (isActive === true) {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_200_CONTACTS_ACTIVATION, code: 300 } as AlertMessageInterface;
          } else {
            alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION_200_CONTACTS_DESACTIVATION, code: 300 } as AlertMessageInterface;
          }
          break;
        case ConstsHelper.PROCEDURE_CHANGE_NETWORK:
          let changeNetworkMessage = ConstsHelper.IN_PROGRESS_MESSAGE_CHANGE_NETWORK;
          if (procedure.date) {
            changeNetworkMessage += ' Le changement sera effectif le <u>' + procedure.date + '</u>.';
          }
          alertMessage = { message: changeNetworkMessage, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_CHANGE_OFFER:
          let changeOfferMessage = ConstsHelper.IN_PROGRESS_MESSAGE_CHANGE_OFFER;
          if (procedure.lastMessage !== null && procedure.lastMessage['data'] && procedure.lastMessage['data']['label_offer'] && procedure.lastMessage['data']['type_change'] === 'next_month') {
            changeOfferMessage += ' Vous bénéficierez du forfait ' + procedure.lastMessage['data']['label_offer'] + ' au début du mois prochain';
          }
          alertMessage = { message: changeOfferMessage + '.', code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_ORDER_SIM_CARD:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_ORDER_SIM_CARD, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_CANCEL_SIM_ORDER:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_CANCEL_SIM_ORDER, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_GENERATE_SEPA_MANDATE:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_GENERATE_SEPA_MANDATE, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_CANCEL_CHANGE_OFFER:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_CANCEL_CHANGE_OFFER, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_CANCEL_CHANGE_NETWORK:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_CANCEL_CHANGE_NETWORK, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_UNBLOCK_LINE:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_UNBLOCK_LINE, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_RECHARGE_DATA:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_RECHARGE_DATA, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_RECHARGE_VOICE:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_RECHARGE_VOICE, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_ACTIVATE_SIM_CARD:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_SIM_CARD_ACTIVATION, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_NOT_RECEIVED_CARD:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_NOT_RECIEVED_CARD + this.selectedLine.phoneNumber + '.', code: 300} as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_TERMINATE_LINE:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_TERMINATE_LINE + procedure.date, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_CANCEL_TERMINATE_LINE:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_CANCEL_TERMINATE_LINE + this.selectedLine.phoneNumber + '.', code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_LOSS_STEAL:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_LOSS_STEAL, code: 300 } as AlertMessageInterface;
          break;
        case ConstsHelper.PROCEDURE_ACTIVATION_5G:
          if (procedure.lastMessage !== null && procedure.lastMessage['data'] && procedure.lastMessage['data']['active'] === true) {
            alertMessage = {message: ConstsHelper.IN_PROGRESS_MESSAGE_5G_ACTIVATION, code: 300} as AlertMessageInterface;
          } else {
            alertMessage = {message: ConstsHelper.IN_PROGRESS_MESSAGE_5G_DEACTIVATION, code: 300} as AlertMessageInterface;
          }
          break;
        case ConstsHelper.PROCEDURE_ACCOUNT_CONSOLIDATION:
          if (procedure.status === 'in_progress' && procedure.lastMessage['data']['accepted'] == null) {
            alertMessage = {message: ConstsHelper.IN_PROGRESS_MESSAGE_ACCOUNT_CONSOLIDATION[0] + procedure.lastMessage['data']['dest_account'] + ConstsHelper.IN_PROGRESS_MESSAGE_ACCOUNT_CONSOLIDATION[1], code: 300} as AlertMessageInterface;
          } else if (procedure.status === 'in_progress' && procedure.lastMessage['data']['accepted'] !== null) {
            const accountConsolidationResponse = procedure.lastMessage['data']['accepted'] === true ? 'de confirmation' : 'd\'annulation';
            alertMessage = {message: ConstsHelper.IN_PROGRESS_MESSAGE_ACCOUNT_CONSOLIDATION[2] + accountConsolidationResponse + ConstsHelper.IN_PROGRESS_MESSAGE_ACCOUNT_CONSOLIDATION[3], code: 300} as AlertMessageInterface;
          }
          break;
        default:
          alertMessage = { message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION, code: 300 } as AlertMessageInterface;
          break;
      }
    }
    this.store.dispatch(new GetAlertMessage(alertMessage));
  }

  displayConflictProcedureMessage(inProgressProcedures: Array<MsisdnProcedureInterface>, clickedProcedure: MsisdnProcedureInterface, phoneNumber: string, specificProceduresList: Array<MsisdnProcedureInterface>) {
    let alertMessage = null;
    for (const procedure of inProgressProcedures) {
      switch (procedure.code) {
        case ConstsHelper.PROCEDURE_CHANGE_NETWORK:
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_CHANGE_OFFER) {
            alertMessage = {
              message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CHANGE_NETWORK_CHANGE_OFFER_CLICKED,
              code: 300
            } as AlertMessageInterface;
          }
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_ORDER_SIM_CARD) {
            alertMessage = {
              message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CHANGE_NETWORK_ORDER_SIM_CARD_CLICKED,
              code: 300
            } as AlertMessageInterface;
          }
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_CANCEL_CHANGE_NETWORK) {
            const today = new Date();
            if (clickedProcedure.timeout.includes(today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear())) {
              const splitTimeout = clickedProcedure.timeout.split(' ');
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CANCEL_CHANGE_NETWORK_CLICKED + 'd\'aujourd\'hui à ' + splitTimeout[1],
                code: 300
              } as AlertMessageInterface;
            } else {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CANCEL_CHANGE_NETWORK_CLICKED + 'du ' + clickedProcedure.timeout.replace(' ', ' à '),
                code: 300
              } as AlertMessageInterface;
            }
          }
          break;
        case ConstsHelper.PROCEDURE_ORDER_SIM_CARD:
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_CHANGE_NETWORK) {
            alertMessage = {
              message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_ORDER_SIM_CARD_CHANGE_NETWORK_CLICKED,
              code: 300
            } as AlertMessageInterface;
          }
          break;
        case ConstsHelper.PROCEDURE_CHANGE_OFFER:
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_CHANGE_NETWORK) {
            alertMessage = {
              message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CHANGE_OFFER_CHANGE_NETWORK_CLICKED,
              code: 300
            } as AlertMessageInterface;
          }
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_CANCEL_CHANGE_OFFER) {
            const today = new Date();
            if (clickedProcedure.timeout.includes(today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear())) {
              const splitTimeout = clickedProcedure.timeout.split(' ');
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CANCEL_CHANGE_OFFER_CLICKED + 'd\'aujourd\'hui à ' + splitTimeout[1],
                code: 300
              } as AlertMessageInterface;
            } else {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CANCEL_CHANGE_OFFER_CLICKED + 'du ' + clickedProcedure.timeout.replace(' ', ' à '),
                code: 300
              } as AlertMessageInterface;
            }
          }
          break;
        case ConstsHelper.PROCEDURE_LOSS_STEAL:
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_CHANGE_NETWORK) {
            if (procedure.lastMessage !== null && procedure.lastMessage['route_value'] == 'service_request') {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_LOSS_STEAL_SVI_CHANGE_NETWORK_CLICKED,
                code: 300
              } as AlertMessageInterface;
            } else {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_LOSS_STEAL_CHANGE_NETWORK_CLICKED,
                code: 300
              } as AlertMessageInterface;
            }
          }
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_ORDER_SIM_CARD) {
            if (procedure.lastMessage !== null && procedure.lastMessage['route_value'] === 'service_request') {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_LOSS_STEAL_SVI_ORDER_SIM_CARD_CLICKED,
                code: 300
              } as AlertMessageInterface;
            } else {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_LOSS_STEAL_ORDER_SIM_CARD_CLICKED,
                code: 300
              } as AlertMessageInterface;
            }
          }
          break;
        case ConstsHelper.PROCEDURE_CANCEL_LOSS_STEAL:
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_CHANGE_NETWORK) {
            if (procedure.lastMessage !== null && procedure.lastMessage['route_value'] == 'service_request') {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_LOSS_STEAL_SVI_CHANGE_NETWORK_CLICKED,
                code: 300
              } as AlertMessageInterface;
            } else {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_LOSS_STEAL_CHANGE_NETWORK_CLICKED,
                code: 300
              } as AlertMessageInterface;
            }
          }
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_ORDER_SIM_CARD) {
            if (procedure.lastMessage !== null && procedure.lastMessage['route_value'] === 'service_request') {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_LOSS_STEAL_SVI_ORDER_SIM_CARD_CLICKED,
                code: 300
              } as AlertMessageInterface;
            } else {
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_LOSS_STEAL_ORDER_SIM_CARD_CLICKED,
                code: 300
              } as AlertMessageInterface;
            }
          }
          break;
        case ConstsHelper.PROCEDURE_NOT_RECEIVED_CARD:
          if (clickedProcedure.code === ConstsHelper.PROCEDURE_LOSS_STEAL) {
            alertMessage = {
              message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_NOT_RECEIVED_CARD_LOSS_STEAL_CLICKED,
              code: 300
            } as AlertMessageInterface;
          } else if (clickedProcedure.code === ConstsHelper.PROCEDURE_CHANGE_OFFER) {
            alertMessage = {
              message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_NOT_RECEIVED_CARD_CHANGE_OFFER_CLICKED,
              code: 300
            } as AlertMessageInterface;
          } else if (clickedProcedure.code === ConstsHelper.PROCEDURE_CHANGE_NETWORK) {
            alertMessage = {
              message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_NOT_RECEIVED_CARD_CHANGE_NETWORK_CLICKED,
              code: 300
            } as AlertMessageInterface;
          } else if (clickedProcedure.code === ConstsHelper.PROCEDURE_ORDER_SIM_CARD) {
            alertMessage = {
              message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_NOT_RECEIVED_CARD_ORDER_SIM_CARD_CLICKED,
              code: 300
            } as AlertMessageInterface;
          }
          break;
      }
    }
    if (alertMessage === null) {
      alertMessage = {message: ConstsHelper.IN_PROGRESS_MESSAGE_MISSION, code: 300} as AlertMessageInterface;
      for (const procedure of specificProceduresList) {
        if (procedure.code === ConstsHelper.PROCEDURE_CANCEL_LOSS_STEAL) {
          switch (clickedProcedure.code) {
            case ConstsHelper.PROCEDURE_CANCEL_LOSS_STEAL:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CANCEL_LOSS_STEAL_CLICKED + 'du ' + clickedProcedure.timeout.replace(' ', ' à '),
                code: 300
              } as AlertMessageInterface;
              break;
            case ConstsHelper.PROCEDURE_LOSS_STEAL:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CANCEL_LOSS_STEAL_LOSS_STEAL_CLICKED + phoneNumber + '.',
                code: 300
              } as AlertMessageInterface;
              break;
            case ConstsHelper.PROCEDURE_CHANGE_OFFER:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CANCEL_LOSS_STEAL_CHANGE_OFFER_CLICKED,
                code: 300
              } as AlertMessageInterface;
              break;
            case ConstsHelper.PROCEDURE_CHANGE_NETWORK:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CANCEL_LOSS_STEAL_CHANGE_NETWORK_CLICKED,
                code: 300
              } as AlertMessageInterface;
              break;
            case ConstsHelper.PROCEDURE_ORDER_SIM_CARD:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_CANCEL_LOSS_STEAL_ORDER_SIM_CARD_CLICKED,
                code: 300
              } as AlertMessageInterface;
              break;
          }
        } else if (procedure.code === ConstsHelper.PROCEDURE_NOT_RECEIVED_CARD) {
          switch (clickedProcedure.code) {
            case ConstsHelper.PROCEDURE_NOT_RECEIVED_CARD:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_NOT_RECEIVED_CARD_CLICKED + clickedProcedure.timeout.replace(' ', ' à '),
                code: 300
              } as AlertMessageInterface;
              break;
            case ConstsHelper.PROCEDURE_LOSS_STEAL:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_NOT_RECEIVED_CARD_LOSS_STEAL_CLICKED,
                code: 300
              } as AlertMessageInterface;
              break;
            case ConstsHelper.PROCEDURE_CHANGE_OFFER:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_NOT_RECEIVED_CARD_CHANGE_OFFER_CLICKED,
                code: 300
              } as AlertMessageInterface;
              break;
            case ConstsHelper.PROCEDURE_CHANGE_NETWORK:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_NOT_RECEIVED_CARD_CHANGE_NETWORK_CLICKED,
                code: 300
              } as AlertMessageInterface;
              break;
            case ConstsHelper.PROCEDURE_ORDER_SIM_CARD:
              alertMessage = {
                message: ConstsHelper.CONFLICT_PROCEDURE_IN_PROGRESS_MESSAGE_NOT_RECEIVED_CARD_ORDER_SIM_CARD_CLICKED,
                code: 300
              } as AlertMessageInterface;
              break;
          }
        }
      }
    }
    this.store.dispatch(new GetAlertMessage(alertMessage));
  }
}
